import { AgencyTags } from "@bagel-web/components";

import FunctionCall from "../../../chalk/FunctionCall";
import { util } from "../../..";
import {
  ClientWorkMark,
  HighlightedText,
  MomentLink,
  MomentLinkCell,
  SourceCell,
} from "../SimpleComponentVisualization";
import { isContentItem, ListItem } from "./limitedListItems";

// Where and how the list renders: what every cell needs beyond its item.
export type ItemView = {
  sessionId: string;
  agentId: string;
  isEditMode?: boolean;
  textFilter: string;
  compact: boolean;
};

// The item's content: its text, or its function call.
export const ItemContent = ({
  item,
  view,
}: {
  item: ListItem;
  view: ItemView;
}) =>
  isContentItem(item) ? (
    <HighlightedText text={item.content!} textFilter={view.textFilter} />
  ) : (
    <FunctionCall
      selectedFn={item.function_call!}
      textHighlight={view.textFilter}
      showMessageWhitespace={!view.compact}
    />
  );

export const ItemSourceCell = ({ item }: { item: ListItem }) => (
  <SourceCell>
    {util.getFriendlySource(item.source)}
    <AgencyTags className="mt-2" tags={item.agency_tags} />
  </SourceCell>
);

// In edit mode an item without origin provenance is the client's own work
// and shows the mark; otherwise the item links to its moment.
export const ItemMomentCell = ({
  item,
  view,
}: {
  item: ListItem;
  view: ItemView;
}) => (
  <MomentLinkCell>
    {view.isEditMode && !(item.moment_id && item.session_id) ? (
      <ClientWorkMark data-testid="limited-list-edited-marker" />
    ) : (
      <MomentLink
        sessionId={view.sessionId}
        agentId={view.agentId}
        item={item}
      />
    )}
  </MomentLinkCell>
);
